import { render } from "./PartnerAtlanticus.vue?vue&type=template&id=51fdb679"
import script from "./PartnerAtlanticus.vue?vue&type=script&lang=js"
export * from "./PartnerAtlanticus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__